// extracted by mini-css-extract-plugin
export default {"tableRow":"newCapex_tableRow__FsWLZ"};